/**
 * CONNEC — Couleur des badges de variante sur les cartes Boost AI
 * ---------------------------------------------------------------------------
 * Le JS de personnalisation de Boost pose la couleur du badge (.connec-top-badge)
 * en style EN LIGNE, avec une valeur codée en dur de son côté. Il consomme bien
 * la section connec-variant-badges du thème, mais son parseur découpe sur « | »
 * et affecte notre couleur à son champ « quantité » : impossible de la lui
 * transmettre. On la corrige donc après coup.
 *
 * Les couleurs et les libellés arrivent par attributs data- sur la balise script,
 * pour qu'aucune valeur ne soit dupliquée dans ce fichier.
 */
(function () {
  'use strict';

  var script = document.currentScript;
  if (!script) return;

  var DEFAULT_COLOR = script.getAttribute('data-default-color') || '';
  var COMING_SOON_COLOR = script.getAttribute('data-coming-soon-color') || '';
  var COMING_SOON_LABELS = (script.getAttribute('data-coming-soon-labels') || '')
    .split('|')
    .map(function (label) { return label.trim().toLowerCase(); })
    .filter(Boolean);

  if (!DEFAULT_COLOR) return;

  function targetColor(badge) {
    var text = (badge.textContent || '').trim().toLowerCase();
    if (!text) return null;
    return COMING_SOON_LABELS.indexOf(text) !== -1 ? COMING_SOON_COLOR : DEFAULT_COLOR;
  }

  function paint(badge) {
    var want = targetColor(badge);
    if (!want) return;

    /**
     * On ne réécrit que si la valeur en ligne a bougé depuis notre dernier passage.
     * Sans ce garde-fou, notre écriture déclencherait l'observateur, qui réécrirait,
     * indéfiniment. La valeur lue après écriture est normalisée par le navigateur
     * (« rgb(...) »), donc on mémorise cette forme-là pour la comparaison.
     */
    if (badge._connecWant === want && badge.style.backgroundColor === badge._connecApplied) return;

    badge.style.backgroundColor = want;
    badge._connecWant = want;
    badge._connecApplied = badge.style.backgroundColor;
  }

  function paintAll(root) {
    if (!root || root.nodeType !== 1) return;
    if (root.classList && root.classList.contains('connec-top-badge')) paint(root);
    var badges = root.querySelectorAll ? root.querySelectorAll('.connec-top-badge') : [];
    for (var i = 0; i < badges.length; i++) paint(badges[i]);
  }

  function start() {
    paintAll(document.body);

    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];

        if (m.type === 'childList') {
          for (var j = 0; j < m.addedNodes.length; j++) paintAll(m.addedNodes[j]);
        } else {
          // style modifié, ou texte du badge remplacé lors d'un changement de couleur
          var node = m.target.nodeType === 1 ? m.target : m.target.parentElement;
          if (node) paintAll(node.closest ? (node.closest('.connec-top-badge') || node) : node);
        }
      }
    }).observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['style']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
